// extracted by mini-css-extract-plugin
module.exports = {"image":"UserImage_image__oElid"};